import { ConfigDocument } from '@bartizo/shared';
import { flattenSettings } from './settings-fields.js';

/**
 * What a setting is when nobody has overridden it anywhere.
 *
 * Taken from the shared schema by parsing an empty document rather than written out
 * here, so the number shown beside "inherited" is the number an agent would
 * actually use — and a default changed in `settings.ts` changes here with it.
 */
const EMPTY = ConfigDocument.parse({
  version: 1,
  hash: `sha256:${'0'.repeat(64)}`,
  roles: ['base'],
  modules: {
    disk: {},
    wazuh_fim: {},
    crowdsec: {},
    db_size: {},
    db_health: {},
    db_exposure: {},
    web_env: {},
    web_traffic: {},
    system: {},
  },
});

export const SCHEMA_DEFAULTS: Readonly<Record<string, unknown>> = Object.freeze({
  ...flattenSettings({ allowlist: EMPTY.allowlist, modules: EMPTY.modules }),
});
